export default "__VITE_ASSET__UT9CMtVE__"